import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullCalendarComponent } from './fullcalendar.component';

@NgModule({
  declarations: [
    FullCalendarComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FullCalendarComponent
  ]
})
export class FullCalendarModule { }
